import { v4 as uuidv4 } from "uuid";
import { FakeLocalStorage } from "../../__mocks__/fakeLocalStorage";
import { LOCAL_STORAGE_PREFIX } from "../constants";

const USER_BROWSER_ID = "browserId";

let storage: Storage;

function setItem(key: any, val: any) {
    storage.setItem(`${LOCAL_STORAGE_PREFIX}${key}`, JSON.stringify(val));
}

function getItem(key: string) {
    const item = storage.getItem(`${LOCAL_STORAGE_PREFIX}${key}`);
    if (item != null) {
        return JSON.parse(item);
    }
    return null;
}

if (localStorage == null) {
    storage = new FakeLocalStorage();
} else {
    storage = localStorage;
}

if (getItem(USER_BROWSER_ID) === null) {
    setItem(USER_BROWSER_ID, uuidv4());
}

function removeItem(key: any) {
    storage.removeItem(`${LOCAL_STORAGE_PREFIX}${key}`);
}

export {
    setItem, getItem, removeItem, USER_BROWSER_ID,
};
